import { ApiMethod } from '@wajeez-web/stores/base';
import { Server, identityClient } from '@wajeez-web/core/api-base';
import { CommonActions, AlertType } from '@wajeez-web/stores/common';

export const getAllRoles: ApiMethod<void, Server.RoleOutput[], any> = async (
  data,
  { dispatch, rejectWithValue }
) => {
  try {
    const client = new Server.Server_Role_Client(undefined, identityClient);
    const response = await client.role_get_V1();
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const addNewRole: ApiMethod<Server.RoleInput, string, any> = async (
  data,
  { dispatch, rejectWithValue }
) => {
  try {
    const client = new Server.Server_Role_Client(undefined, identityClient);
    const response = await client.role_post_V1(data);
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const deletRolebyId: ApiMethod<string, void, any> = async (
  data,
  { dispatch, rejectWithValue }
) => {
  try {
    const client = new Server.Server_Role_Client(undefined, identityClient);
    const response = await client.role_id_delete_V1(data);
    if (response.success) {
      return;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getRolePermissions: ApiMethod<
  string,
  Server.RolePermissionOutput,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Role_Client(undefined, identityClient);
    const response = await client.role_permissions_roleId_get_V1(data);
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const updateRolePermissions: ApiMethod<
  Server.PermissionInput,
  void,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Role_Client(undefined, identityClient);
    const response = await client.role_permissions_update_put_V1(data);
    if (response.success) {
      return;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getallroleclaims: ApiMethod<
  void,
  Server.RoleClaimOutput[],
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_RoleClaim_Client(
      undefined,
      identityClient
    );
    const response = await client.roleClaim_get_V1();
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};
